import { isParamValid } from "../utils";

/**
 * Meta's `fbc` format is `fb.<subdomainIndex>.<creationTime>.<fbclid>`, where
 * `subdomainIndex` is the number of dots in the host the value belongs to.
 * Computed from the live hostname rather than hardcoded, since it depends on
 * where the app is actually served.
 */
export const subdomainIndex = (hostname: string): number =>
  hostname.split(".").length - 1;

const FBC_PREFIX = /^fb\.\d+\.\d+\./;

/**
 * Builds the `_fbc` match key. Prefers an existing, well-formed `_fbc` cookie
 * (already written by Meta Pixel itself, or by a previous visit) over
 * reconstructing one, so this never clobbers a value Meta already produced.
 */
export const buildFbc = (input: {
  fbclid: string | null;
  existingFbc: string | null;
  hostname: string;
  now: number;
}): string | null => {
  if (isParamValid(input.existingFbc) && FBC_PREFIX.test(input.existingFbc)) {
    return input.existingFbc;
  }

  if (!isParamValid(input.fbclid)) {
    return null;
  }

  if (FBC_PREFIX.test(input.fbclid)) {
    return input.fbclid;
  }

  return `fb.${subdomainIndex(input.hostname)}.${input.now}.${input.fbclid}`;
};
